import { render } from "./PopularMovies.vue?vue&type=template&id=55993d97&scoped=true"
import script from "./PopularMovies.vue?vue&type=script&lang=js"
export * from "./PopularMovies.vue?vue&type=script&lang=js"

import "./PopularMovies.vue?vue&type=style&index=0&id=55993d97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55993d97"]])

export default __exports__